import React, { Component } from "react";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/material";

export class Progress extends Component {
  BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: this.props.color,
    },
  }));
  render() {
    return (
      <Box sx={{ width: this.props.width, display: "block", margin: "auto"}}>
        <Grid container justifyContent="space-between" mb={0.2}>
          <Grid item>
            <Typography gutterBottom variant="body2" color="text.disabled">
            {this.props.prefix ? this.props.prefix : '£'}{this.props.showNumbers === "false" ? "" : this.props.startNumber}{this.props.suffix?this.props.suffix:null} {this.props.startText}
            </Typography>
          </Grid>
          <Grid item>
            <Typography gutterBottom variant="body2" fontWeight={this.props.fontWeight?this.props.fontWeight:700} fontSize={this.props.fontSize?this.props.fontSize:"0.85rem"}>
            {this.props.prefix ? this.props.prefix : '£'}{this.props.showNumbers === "false" ? "" : this.props.endNumber}{this.props.suffix?this.props.suffix:null} {this.props.endText}
            </Typography>
          </Grid>
        </Grid>

        <this.BorderLinearProgress
          variant="determinate"
          value={
            this.props.showAsPercentage?
            this.props.startNumber > 100 ? 
            100 : this.props.startNumber :
            ((this.props.startNumber)/(this.props.startNumber + this.props.endNumber))*100 > 100 ? 
            100 :((this.props.startNumber)/(this.props.startNumber + this.props.endNumber))*100
          }
          
          gutterBottom
          mb={2}
        />
      </Box>
    );
  }
}

export default Progress;
